export const AllowedInstanceTypes = {
  T2NANO: 't2.nano',
  T2MICRO: 't2.micro',
  T2SMALL: 't2.small',
  T2MEDIUM: 't2.medium',
  T3ANANO: 't3a.nano',
  T3AMICRO: 't3a.micro',
  T3ASMALL: 't3a.small',
  T3AMEDIUM: 't3a.medium',
} as const;

export type AllowedInstanceTypes = (typeof AllowedInstanceTypes)[keyof typeof AllowedInstanceTypes];
